module.exports = __webpack_public_path__ + "img/downloadphone.03a023ee.png";